import ChatbotAnalytics from "./ChatbotAnalytics";

const ChatbotAnalyticsConfig = {
	settings: {},
	routes: [
		{
			path: '/chatbot/analytics',
			component: ChatbotAnalytics
		}
	]
};

export default ChatbotAnalyticsConfig;
